import axios from 'axios';

const getBaseURL = () => {
    // 1. If explicit environment variable is set
    if (process.env.REACT_APP_SVF_BACKENDHOST && process.env.REACT_APP_SVF_BACKENDHOST.trim()) {
        return `${process.env.REACT_APP_SVF_BACKENDHOST.trim()}/api`;
    }
    // 2. In local development running React Dev Server on port 3000
    if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') && window.location.port === '3000') {
        return 'http://localhost:2621/api';
    }
    // 3. In deployed production (served directly by backend/nginx), use relative /api
    return '/api';
};

const api = axios.create({
    baseURL: getBaseURL()
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token') || localStorage.getItem('sv_token');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    // Attach selected organization scope for Superadmin
    const activeOrgId = localStorage.getItem('sv_active_org_id');
    if (activeOrgId) {
        config.headers['X-Org-Id'] = activeOrgId;
    }

    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const isAuthReq = error.config && error.config.url && error.config.url.includes('/auth/login');
            if (!isAuthReq) {
                // Token invalid or expired: clear session and redirect to login
                localStorage.removeItem('token');
                localStorage.removeItem('sv_token');
                localStorage.removeItem('sv_user');
                if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }
            }
        }
        return Promise.reject(error);
    }
);

export default api;